import { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";

let cache = { at: 0, data: null, promise: null };
const TTL = 60_000;

function fetchDuties() {
  if (cache.data && Date.now() - cache.at < TTL) return Promise.resolve(cache.data);
  if (!cache.promise) {
    cache.promise = api.get("/pto/covering")
      .then((r) => { cache = { at: Date.now(), data: r.data, promise: null }; return r.data; })
      .catch(() => { cache.promise = null; return []; });
  }
  return cache.promise;
}

// Teammates I'm covering for (approved time off), and a check for "can I act as this task's owner?".
export function useCoverDuties() {
  const [duties, setDuties] = useState(cache.data || []);
  useEffect(() => { fetchDuties().then(setDuties); }, []);
  const covers = useCallback(
    (task) => !!task?.owner_id && duties.some((d) => d.active && d.user_id === task.owner_id && d.cover_project_ids.includes(task.project_id)),
    [duties],
  );
  return { duties, covers };
}
